import { CreateVideoComponent } from '@/pages/Event/components/CreateVideo';

export const CreateVideo = () => {
  return <CreateVideoComponent />;
};
